import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'A visual technical reference to understand, maintain and operate diesel engines and generator sets. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-slate-300 antialiased" data-id="element-0" data-mp="nuhjilyq8hvv">
      <MetaPixel data-id="element-1" data-mp="stccggqermtp" />
      <main data-id="element-2" data-mp="ssstcwp0use3">
        <Hero data-id="element-3" data-mp="swgmhuqk1csa" />
        <LookInsideCarousel data-id="element-4" data-mp="3685nh1tcguh" />
        <ProblemSection data-id="element-5" data-mp="35glr3hkw7k1" />
        <SystemSection data-id="element-6" data-mp="34x4lozr5n72" />
        <ModulesSection data-id="element-7" data-mp="38b7cycbvyf1" />
        <BonusSection data-id="element-8" data-mp="3udavo55x0h34" />
        <UrgencySection data-id="element-9" data-mp="3ubri4mbn8k51" />
        <PricingSection data-id="element-10" data-mp="3ucjdpx58qhvb" />
        <GuaranteeSection data-id="element-11" data-mp="d4nx5l4r5s4i" />
        <FAQ data-id="element-12" data-mp="d4xp3e9cy9cu" />
        <ClosingSection data-id="element-13" data-mp="d3mmhhrnf7nb" />
        <SummaryTable data-id="element-14" data-mp="d3wcv6glvgtj" />
        <FinalCta data-id="element-15" data-mp="d2bf77yzvhrg" />
      </main>
      <Footer data-id="element-16" data-mp="85bbh3pmar3i" />
      <PurchaseNotification data-id="element-17" data-mp="86mc4unrniqe" />
    </div>;
}